import { Plus } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useState } from "react";


import DropSelectInput from "@/components/form-controls/DropSelectInput";
import TextInput from "@/components/form-controls/TextInput";
import ShareHolderModal from "../fragments/share-holder-modal";
import ShareholderList from "../fragments/share-holder-list";





export default function CapitalInvestmentForm() {
    const [open, setOpen] = useState<boolean>(false);
    const { register, formState: { errors }, clearErrors, setValue ,control} = useFormContext()
    const { fields: shareHolders, append, remove } = useFieldArray({ control, name: "shareHolders" });

    const handleValueChange = (value: number, field: string) => {
        switch(field) {
          case "estimatedInvestment":
            setValue(`estimatedInvestment.amount`, value);
            break;
          case "personalContribution":
            setValue(`personalContribution.amount`, value);
            break;
          case "loan":
            setValue(`loan.amount`, value);
            break;
        }
      };
    
      const handleCurrencyChange = (currency: string, field: string) => {
        switch(field) {
          case "estimatedInvestment":
            setValue(`estimatedInvestment.currency`, currency);
            break;
          case "personalContribution":
            setValue(`personalContribution.currency`, currency);
            break;
          case "loan":
            setValue(`loan.currency`, currency);
            break;
        }
      };

    const handleInputBlur = (fieldName: string) => {
        if (errors[fieldName]) {
            clearErrors(fieldName);
        }
    }

    return (
        <div className="w-full">
            <h1 className="text-lg font-bold">Capital Investment</h1>
            <p className="text-xs text-[#041528]">Detail the financial structure of your investment</p>
            <div className="mt-5 grid grid-cols-1 gap-3 w-full">

                <TextInput
                    label="Company Operating the Project"
                    placeholder="Enter company name operating you project."
                    onBlur={() => handleInputBlur("companyName")}
                    error={errors.companyName?.message?.toString()}
                    register={register("companyName", {
                        required: "Company Name is required"
                    })}
                    className=" placeholder:font-extralight"
                    required
                />

                <DropSelectInput
                    label="Estimated Investment Amount"
                    // @ts-ignore
                    error={errors?.estimatedInvestment?.amount?.message.toString()}
                    onValueChange={(value) => handleValueChange(value, "estimatedInvestment")}
                    onCurrencyChange={(currency) => handleCurrencyChange(currency, "estimatedInvestment")}
                    register={register("estimatedInvestment.amount", {
                    required: "Investment amount is required",
                    valueAsNumber: true,
                    })}
                    registerCurrency={register("estimatedInvestment.currency", {
                    required: "Currency is required"
                    })}
                    onBlur={() => handleInputBlur("estimatedInvestment")}
                    required
                />

                <div className="flex items-center gap-3">
                    <DropSelectInput
                        label="Personal Contribution"
                        // @ts-ignore
                        error={errors.personalContribution?.['amount']?.message}
                        onValueChange={(value) => handleValueChange(value, "personalContribution")}
                        onCurrencyChange={(currency) => handleCurrencyChange(currency, "personalContribution")}
                        register={register("personalContribution.amount", {
                            required: "Personal Contribution is required",
                            valueAsNumber: true,
                        })}
                        registerCurrency={register("personalContribution.currency", {
                            required: "Currency is required"
                        })}
                        required
                       onBlur={() => handleInputBlur("personalContribution")}

                        />

                    <DropSelectInput
                        label="Loan Amount"
                        // @ts-ignore
                        error={errors.loan?.amount?.message}
                        onValueChange={(value) => handleValueChange(value, "loan")}
                        onCurrencyChange={(currency) => handleCurrencyChange(currency, "loan")}
                        register={register("loan.amount", {
                            required: "Loan Amount is required",
                            valueAsNumber: true,
                        })}
                        registerCurrency={register("loan.currency", {
                            required: "Currency is required"
                        })}
                        required
                       onBlur={() => handleInputBlur("loan")}

                        />
                </div>

                <TextInput
                    label="Institution Providing the Loan"
                    placeholder="Enter institution name providing the loan"
                    onBlur={() => handleInputBlur("institutionName")}
                    error={errors.institutionName?.message?.toString()}
                    register={register("institutionName", {
                        required: "Institution Name is required"

                    })}
                    className=" placeholder:font-extralight"
                    required
                />

                <div className="flex items-center w-full gap-3">

                    <TextInput
                        label="Bank Name"
                        placeholder="Enter Bank Name"
                        onBlur={() => handleInputBlur("bankName")}
                        error={errors.bankName?.message?.toString()}
                        register={register("bankName", {
                            required: "Bank Name is required"
                        })}
                        className="w-full placeholder:font-extralight"
                        required

                    />

                    <TextInput
                        label="Bank Address"
                        placeholder="Enter Bank Address"
                        onBlur={() => handleInputBlur("bankAddress")}
                        error={errors.bankAddress?.message?.toString()}
                        register={register("bankAddress", {
                            required: "Bank Address is required"
                        })}
                        className="w-full placeholder:font-extralight"
                        required
                    />
                    
                </div>

                <div className="flex items-center w-full text-sm gap-3 ">
                    <span className="text-nowrap text-black font-semibold">Ownership and Share Distribution</span>
                    <span className="border border-[#E3E7E8] w-full h-[0.5px]" />
                </div>
                <div className="mt-2">
                    <div className="flex justify-between w-full">
                        <div>
                            <span className="text-lg font-bold">Shareholders</span>
                        </div>
                        <div
                            onClick={() => setOpen(true)}
                            className="text-primary cursor-pointer space-x-5 text-sm inline-flex items-center">
                            <Plus
                                className="text-primary"
                                size={17}
                            />
                            Shareholder
                        </div>
                    </div>

                    <ShareholderList 
                        shareholders={shareHolders}
                        onEdit={(id) => {
                            setOpen(true);
                            console.log(id,"Yes")
                        }}
                        onRemove={(id) => remove(shareHolders.findIndex(sh => Number(sh.id) === Number(id)))}
                    />


                    <>
                        <ShareHolderModal
                                isOpen={open}
                                onClose={() => setOpen(false)}
                                onAddShareholder={(data) => append(data)} 
                        />
                    </>
                </div>
            </div>
        </div>
    )
}